export const STANDARD_TIMEZONE_OPTIONS = [
    { value: 'America/New_York', label: 'Eastern (America/New_York)' },
    { value: 'America/Chicago', label: 'Central (America/Chicago)' },
    { value: 'America/Denver', label: 'Mountain (America/Denver)' },
    { value: 'America/Los_Angeles', label: 'Pacific (America/Los_Angeles)' },
    { value: 'America/Phoenix', label: 'Arizona (America/Phoenix)' },
    { value: 'America/Anchorage', label: 'Alaska (America/Anchorage)' },
    { value: 'Pacific/Honolulu', label: 'Hawaii (Pacific/Honolulu)' },
    { value: 'America/Puerto_Rico', label: 'Atlantic (America/Puerto_Rico)' },
    { value: 'UTC', label: 'UTC' },
];

export const STANDARD_TZ_VALUES = new Set(STANDARD_TIMEZONE_OPTIONS.map((o) => o.value));

export const RINGING_INTERVAL = 3000;
export const RINGING_TIMEOUT = 40000;
export const AUTO_REJECT_TIMEOUT = 10000; // 10 seconds

export const HEARTBEAT_INTERVAL = 10000;
export const HEARTBEAT_TIMEOUT = 65000;

export const PARTY_STAGES = {
    PartyStageNewLead: 'New Lead',
    PartyStageLostOpportunity: '$225 Lost Opportunity',
    PartyStageOutreach: 'Outreach',
    PartyStageExistingClient: 'Existing Case Client',
    PartyStageUnqualified: 'Unqualified',
    PartyStageUnableToContact: 'Unable to Contact',
    PartyStageOpenConsult: 'Open Consult',
    PartyStagePitchedPending: '$225 Pitched - Pending',
};
